import { render, staticRenderFns } from "./ring.vue?vue&type=template&id=7fdfad8a&scoped=true&"
import script from "./ring.vue?vue&type=script&lang=js&"
export * from "./ring.vue?vue&type=script&lang=js&"
import style0 from "./ring.vue?vue&type=style&index=0&id=7fdfad8a&prod&scoped=true&lang=css&"
import style1 from "./ring.vue?vue&type=style&index=1&id=7fdfad8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdfad8a",
  null
  
)

export default component.exports